import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20golden%20butter%20and%20dairy%20products%20arranged%20elegantly%20on%20a%20rustic%20wooden%20table%20with%20soft%20natural%20sunlight%2C%20cream%20colored%20minimalist%20background%2C%20artistic%20food%20photography%2C%20warm%20amber%20tones%2C%20high%20detail%2C%20luxurious%20presentation%2C%20abstract%20bokeh%20texture&width=1800&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="在线黄油 - 精选优质黄油"
          className="w-full h-full object-cover object-center"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/15 to-black/30"></div>

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6 text-center py-20">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 mb-6 leading-tight">
          正品黄油
          <br className="md:hidden" />
          <span className="text-primary-300">在线选购平台</span>
        </h1>
        <p className="text-base md:text-lg text-background-100/90 max-w-2xl mx-auto mb-8 leading-relaxed">
          精选国内外优质黄油品牌，涵盖发酵黄油、无盐黄油、动物黄油等多种类型
          <br className="hidden md:block" />
          冷链直达，品质保证，让您轻松在线选购无忧
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/categories"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 rounded-md text-base font-medium hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-shopping-bag-3-line"></i>
            </span>
            立即选购
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-background-50/20 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-md text-base font-medium hover:bg-background-50/30 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>

        <div className="mt-14 grid grid-cols-3 gap-6 max-w-2xl mx-auto">
          {[
            { icon: 'ri-shield-check-line', label: '正品保障' },
            { icon: 'ri-truck-line', label: '冷链直达' },
            { icon: 'ri-customer-service-2-line', label: '贴心服务' },
          ].map((item) => (
            <div key={item.label} className="flex flex-col items-center gap-2">
              <div className="w-12 h-12 rounded-full bg-background-50/20 backdrop-blur-sm flex items-center justify-center">
                <span className="w-6 h-6 flex items-center justify-center text-background-50">
                  <i className={`${item.icon} text-xl`}></i>
                </span>
              </div>
              <span className="text-sm text-background-100/90 font-medium whitespace-nowrap">{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}